import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/flags/en_flag.png'
import _imports_1 from '@/assets/flags/hu_flag.png'
import _imports_2 from '@/assets/flags/ro_flag.png'


const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BNavbarBrand = _resolveComponent("BNavbarBrand")!
  const _component_BNavbarToggle = _resolveComponent("BNavbarToggle")!
  const _component_BDropdownItem = _resolveComponent("BDropdownItem")!
  const _component_BDropdown = _resolveComponent("BDropdown")!
  const _component_BNavItem = _resolveComponent("BNavItem")!
  const _component_BNavbarNav = _resolveComponent("BNavbarNav")!
  const _component_CalendlyPopup = _resolveComponent("CalendlyPopup")!
  const _component_BCollapse = _resolveComponent("BCollapse")!
  const _component_BNavbar = _resolveComponent("BNavbar")!

  return (_openBlock(), _createBlock(_component_BNavbar, {
    toggleable: "lg",
    type: "light",
    variant: _ctx.scrolledPastCarousel ? 'dark' : 'transparent',
    class: "px-4 sticky-top"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_BNavbarBrand, {
        href: "#",
        onClick: _ctx.scrollToTop
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("TeoPath")
        ])),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_BNavbarToggle, { target: "nav-collapse" }),
      _createVNode(_component_BCollapse, {
        id: "nav-collapse",
        isNav: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BNavbarNav, null, {
            default: _withCtx(() => [
              _createVNode(_component_BDropdown, {
                text: _ctx.t('aboutMeShortly'),
                variant: "primary",
                class: _normalizeClass(["language-dropdown mx-2", { 'active-menu': _ctx.isParentActive(['aboutMe', 'studies', 'expertises', 'affiliations']) }])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BDropdownItem, {
                    to: { path: '/', hash: '#aboutMe' },
                    class: _normalizeClass(["menu-item", { 'active-submenu': _ctx.isActive(['aboutMe']) }])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('sectionAboutMe.aboutMe')), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_BDropdownItem, {
                    to: { path: '/', hash: '#studies' },
                    class: _normalizeClass(["menu-item", { 'active-submenu': _ctx.isActive(['studies']) }])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('sectionStudies.studies')), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_BDropdownItem, {
                    to: { path: '/', hash: '#expertises' },
                    class: _normalizeClass(["menu-item", { 'active-submenu': _ctx.isActive(['expertises']) }])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('sectionExpertises.expertises')), 1)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_BDropdownItem, {
                    to: { path: '/', hash: '#affiliations' },
                    class: _normalizeClass(["menu-item", { 'active-submenu': _ctx.isActive(['affiliations']) }])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('sectionAffiliations.affiliations')), 1)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }, 8, ["text", "class"]),
              _createVNode(_component_BNavItem, {
                to: { name: 'Services' },
                class: _normalizeClass(["mx-2", { 'active-menu': _ctx.isActive(['services']) }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('sectionServices.services')), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_BNavItem, {
                to: { path: '/', hash: '#contacts' },
                class: _normalizeClass(["mx-2", { 'active-menu': _ctx.isActive(['contacts']) }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('sectionContacts.contacts')), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }),
          _createVNode(_component_BNavbarNav, { class: "ms-auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_BNavItem, null, {
                default: _withCtx(() => [
                  _createVNode(_component_CalendlyPopup)
                ]),
                _: 1
              }),
              _createVNode(_component_BDropdown, {
                variant: "primary",
                class: "language-dropdown mx-2",
                "menu-class": "dropdown-transparent"
              }, {
                "button-content": _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.currentFlag,
                    alt: "Language",
                    class: "flag-icon"
                  }, null, 8, _hoisted_1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_BDropdownItem, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLanguage('en')))
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: "English",
                        class: "flag-icon"
                      }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_BDropdownItem, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLanguage('hu')))
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createElementVNode("img", {
                        src: _imports_1,
                        alt: "Hungarian",
                        class: "flag-icon"
                      }, null, -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_BDropdownItem, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeLanguage('ro')))
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        alt: "Romanian",
                        class: "flag-icon"
                      }, null, -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["variant"]))
}